export enum AdminNotificationTypeEnums {
    CONTACT_US = 'CONTACT_US',
    REPORT = 'REPORT',
    PROPERTY = 'PROPERTY',
    SUBSCRIPTION_CANCEL = 'SUBSCRIPTION_CANCEL',
  }
  